import { RouteConfig } from 'vue-router'
import { 
  VISIT_IAM_APP,
  VISIT_ERP_APP
} from './constants/policies'
import omc from '@rhitics/omc/config'
import pic from '@rhitics/pic/config'
import console from '@rhitics/console/config'

import crawler from '@rhitics/crawler/config'
import crawlerRoute from '@rhitics/crawler/routes'

import sic from '@rhitics/sic/config'
import sicRoutes from '@rhitics/sic/routes'


export interface AppConfig {
  name: string
  prefix?: string
  isMoveToNewSite?: boolean
  shortName: string
  icon: string
  description: string
  policy: string | null
  ns: string
  document?: string
}

export interface AppSubSystemConfig extends AppConfig {
  routes: RouteConfig[]
  store?: any
}

export type AppConfigs = AppConfig[]

export const home = {
  name: 'RHITICS',
  prefix: '',
  shortName: 'RHITICS',
  icon: 'fas fa-home',
  ns: 'RHITICS',
  description: 'RHITICS home',
  policy: null,
  isMoveToNewSite: false
}

export const apps: AppConfigs = [home, pic, omc, console]

export const internalApps: AppSubSystemConfig[] = [
  {
    ...sic,
    routes: sicRoutes
  },
  {
    name: 'IAM',
    shortName: 'IAM',
    icon: 'fas fa-shield-alt',
    description: 'Identity and Access Management',
    policy: VISIT_IAM_APP,
    ns: 'IAM',
    isMoveToNewSite: true,
    document: 'https://docs.google.com/document/d/1s1Hnq39tCd7D4G15e7KLs9ixi7Kpl3bq6w2u7jU6txs/edit?usp=sharing',
    routes: []
  },
  {
    ...crawler,
    routes: crawlerRoute
  },
  {
    name: 'ERP Management',
    description: 'ERP Setting.',
    ns: 'ErpNS',
    policy: VISIT_ERP_APP,
    shortName: 'ERP',
    icon: 'fas fa-tools',
    isMoveToNewSite: true,
    routes: []
  }
]

export function getApps(type?: 'external' | 'internal') {
  return !!type
    ? type === 'external'
      ? apps
      : internalApps
    : {
        internal: internalApps,
        external: apps
      }
}

export function getAppConfig(app: string) {
  const allAppConfig = [
    ...apps,
    ...internalApps
  ]

  const config = allAppConfig.find(config => config.name === app)

  return config
}
